export const StringUtils = {
    isEmpty: (str: string | null | undefined) => {
        return str === null || str === undefined || str.trim() === '';
    },
    isNotEmpty: (str: string | null | undefined) => !StringUtils.isEmpty(str),
};